import { useLocationHash, useNavigate } from '@rocketlane/rocket-router';
import { fromPairs, toPairs } from 'lodash';
import { parse, stringify } from 'utils/query-string';
import { useCallback, useMemo } from 'react';
import { useHashRevision } from './use-hash-revision';
import { useLatest } from './use-latest';
export const DEFAULT_TRANSFORMER = {
    from: (parsed)=>parsed,
    to: (value)=>value
};
const sanitize = (value)=>fromPairs(toPairs(value).filter(([, x])=>x != null));
export const useHash = ({ from, to })=>{
    // Renders on hash changes the router does not deliver; `useLocationHash` below
    // is still the value. See `use-hash-revision` for why this is needed.
    useHashRevision();
    const hash = useLocationHash();
    const navigate = useNavigate();
    const parsed = useMemo(()=>sanitize(parse(hash)), [
        hash
    ]);
    const value = useMemo(()=>from(parsed), [
        parsed,
        from
    ]);
    const getNext = useCallback((next)=>`#${stringify(sanitize({
            ...parsed,
            ...to(next)
        }))}`, [
        parsed,
        to
    ]);
    const setValue = useCallback((next, replace = false)=>{
        var _window_history_state;
        const next_hash = getNext(next);
        if (hash === next_hash) {
            return;
        }
        navigate({
            pathname: window.location.pathname,
            hash: next_hash,
            search: window.location.search
        }, {
            replace,
            state: (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.usr
        });
    }, [
        getNext,
        hash,
        navigate
    ]);
    const setValueLatest = useLatest(setValue);
    const getNextLatest = useLatest(getNext);
    return [
        value,
        setValueLatest,
        getNextLatest
    ];
};
